export const getImage = (imageName, type) => {
  let folderName = "";

  // Images uploaded via the admin panel are served by the backend
  // (e.g. "/uploads/categories/xxx.jpg") rather than bundled at build time.
  if (
    imageName &&
    (imageName.startsWith("/uploads/") || imageName.startsWith("http"))
  ) {
    return imageName;
  }

  try {
    if (type === "categories") {
      folderName = "img_categories";
    } else if (type === "products") {
      folderName = "img_products";
    }
    if (imageName && imageName !== "") {
      return require(`../Assets/Images/${folderName}/${imageName}`);
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};

export const formatDate = (date) => {
  let datePart = [date.getFullYear(), date.getMonth() + 1, date.getDate()]
    .map((n, i) => n.toString().padStart(i === 2 ? 4 : 2, "0"))
    .join("-");
  let timePart = [date.getHours(), date.getMinutes(), date.getSeconds()]
    .map((n, i) => n.toString().padStart(2, "0"))
    .join(":");
  return datePart + " " + timePart;
};

export const formatNumberConditionalDecimal = (number) => {
  if (number % 1 !== 0) {
    // Check if the number has a decimal part
    return parseFloat(number).toFixed(2); // Format to two decimal places if it does
  } else {
    return parseFloat(number).toString(); // Convert to string without decimals if it's an integer
  }
};

export const formatProductDetails = (text) => {
  if (!text) return [];

  const toSentenceCase = (str) => {
    return str
      .toLowerCase()
      .replace(/(^\s*\w|:\s*\w)/g, (c) => c.toUpperCase());
  };

  return text
    .split("||")
    .map((item) => toSentenceCase(item.trim()))
    .filter(Boolean);
};
